import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FacialRecognitionService, MemberQuery } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Subscription } from 'rxjs';
import { FacialRecognitionUploaderInfoComponent } from '../facial-recognition-uploader-info/facial-recognition-uploader-info.component';

@Component({
  selector: 'fgb-facial-recognition-entry',
  templateUrl: './facial-recognition-entry.component.html',
  styleUrl: './facial-recognition-entry.component.scss',
})
export class FacialRecognitionEntryComponent implements OnInit, OnDestroy {
  @Input() facialRecognitionLink: string = '/facial-recognition';
  facialRecognitionImage: string | any;
  private facialSub: Subscription;
  private isRequestInProgress = false;

  constructor(
    private facialRecognitionService: FacialRecognitionService,
    private memberQuery: MemberQuery,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.getFacialRecognitionImage();
    this.facialSub = this.facialRecognitionService.facialObservable$.subscribe(() => {
      this.modalService.dismissAll();
      this.getFacialRecognitionImage();
    });
  }

  getFacialRecognitionImage() {
    if (this.isRequestInProgress) return;

    this.isRequestInProgress = true;

    firstValueFrom(this.facialRecognitionService.fetchFacialImage(this.memberQuery.getUserContext().memberId)).then(
      (response) => {
        let reader = new FileReader();
        reader.readAsDataURL(response);
        reader.onload = (_event) => {
          this.facialRecognitionImage = reader.result;
        };
        this.isRequestInProgress = false;
      }
    );
  }

  ngOnDestroy() {
    this.facialSub?.unsubscribe();
  }

  goToFacialRecognition() {
    const modalRef = this.modalService.open(FacialRecognitionUploaderInfoComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'facial-recognition-selection-modal',
      centered: true,
    });

    modalRef.componentInstance.isfacialRouteLinkDisabled = false;
    modalRef.componentInstance.facialRecognitionLink = this.facialRecognitionLink;
    modalRef.result.then(
      (result) => {
        if (result) {
          this.facialRecognitionService.uploadedImage = result.uploadedImageForm;
          this.facialRecognitionService.formData = result.formData;
          this.facialRecognitionService.isUploadInfo = result.isUploadInfo;
          this.facialRecognitionService.goToStep = result.goToStep;
        }
      },
      (reason) => {}
    );
  }
}
